import './App.css';
import ClashPortfolio from './ClashPortfolio';

function App() {
  return (
    <div className="App">
      <ClashPortfolio />
    </div>
  );
}

export default App;
